module.exports = __webpack_public_path__ + "04_long_black.37b795cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/04_long_black.png
// module id = 17Z2
// module chunks = 0